import fetchServer from "../fetchServer";

export default async function updateFullPrivilege(
  accountId,
  { hasFullPrivilege },
) {
  let result = {
    return: 0,
    msg: "Something went wrong updating full privilege!",
  };

  await fetchServer({
    method: "PATCH",
    url: `/main/v1/account/fullPrivilege/${accountId}`,
    data: { hasFullPrivilege },
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = {
          return: 1,
          msg: res?.data?.message || "Successful",
          data: res.data?.data ?? res.data,
        };
      } else {
        result.msg = res?.data?.error || result.msg;
      }
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
